module.exports = __webpack_public_path__ + "static/media/data-correction-icon-final.69f03268.svg";